import tmhRequest from '@/config/tmhRequest'

export default {
    createSettlementOrder: function (data) {
        return tmhRequest({
            url: '/finance/tmh/settlementorder/createsettlementorder',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/finance/settlementorder.js